import buttonStyles from '../../components/Button/Button.module.scss'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Tab } from 'react-bootstrap'
import { UserAvatar } from '../../components/UserAvatar/UserAvatar'
import { ProfileSettingsTab } from './ProfileSettingsTab'
import { NavLink, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Tabs } from '../../components/Tabs/Tabs'
import { useAppSelector } from '../../store/hooks'
import { useDocumentTitle } from '../../common/useDocumentTitle'
import { useGetMeQuery } from '../../store/user/user'
import { selectAccountId } from '../../store/auth/authSlice'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { MeetingAssistantTab } from './MeetingAssistantTab'
import { useZocksQuota } from '../../components/ScopedBlock/hooks'
import { CollaborationTab } from './CollaborationTab'
import PrizeBadge from '../../components/ScopedBlock/PrizeBadge.svg?url'
import { MFATab } from './MFATab'

export const ProfileSettings: React.FC = () => {
  useDocumentTitle('Profile')
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId: accountId })
  return (
    <Container fluid>
      <Row className='mb-9'>
        <Col className='p-0'>
          <Container>
            <Row>
              <Col xs='auto'>
                <UserAvatar width='72px' height='72px' fontSize='40px' />
              </Col>
              <Col>
                <Row>
                  <Col>
                    <h3>{currentUser ? getUserDisplayName(currentUser) : null}</h3>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='p-medium zocks-text-gray-600'>{currentUser?.email}</div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Col>
        <Col className='d-none d-md-flex align-items-center ' xs='auto'>
          <NavLink className={`${buttonStyles.button} ${buttonStyles.primaryGhostButton}`} to={'/account/manage-team'}>
            View all people
          </NavLink>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ProfileSettingsTabs />
        </Col>
      </Row>
    </Container>
  )
}

export const ProfileSettingsTabs: React.FC = () => {
  const { activeTab = 'profile-settings' } = useParams()
  const [selectedTab, setSelectedTab] = useState(activeTab)

  const navigate = useNavigate()

  const { hasQuota } = useZocksQuota()
  const sessionSharingAvailable = hasQuota('identity.sessionSharingEnabled.value')
  const [searchParams] = useSearchParams()

  useEffect(() => {
    navigate(
      {
        pathname: `/account/profile-settings/${selectedTab}`,
        search: searchParams.toString(),
      },
      { replace: true },
    )
  }, [selectedTab, navigate, searchParams])

  const changeTab = (key: string | null) => {
    if (key) {
      setSelectedTab(key)
    }
  }

  useEffect(() => {
    changeTab(activeTab)
  }, [activeTab])

  const collaborationTitle = (
    <div className='d-flex align-items-center'>
      {!sessionSharingAvailable ? <img alt='Upgrade' src={PrizeBadge} /> : ''}
      Collaboration
    </div>
  )

  return (
    <Tabs className='mb-6' defaultActiveKey={selectedTab} onSelect={changeTab} id='profile-settings-tabs' activeKey={selectedTab}>
      <Tab eventKey='profile-settings' id='Profile Settings' title='Profile Settings'>
        <ProfileSettingsTab />
      </Tab>
      {/*<Tab eventKey='notifications' id='Notifications' title='Notifications'>*/}
      {/*  <NotificationsTab />*/}
      {/*</Tab>*/}
      <Tab eventKey='meeting-assistant' id='Meeting Assistant' title='Meeting Assistant'>
        <MeetingAssistantTab />
      </Tab>
      <Tab eventKey='collaboration' id='Collaboration' title={collaborationTitle}>
        <CollaborationTab />
      </Tab>
      <Tab eventKey='mfa' id='MFA' title='2-factor authentication'>
        <MFATab />
      </Tab>
    </Tabs>
  )
}
